import React, { Component } from "react";
import { connect } from "react-redux";
import CompanyProfile from "../components/CompanyProfile/CompanyProfile";
import {
  fetchCompanySizes,
  fetchIndustries
} from "../../../../actions/dropdowns.actions";
import { updateCompany } from "../../../../actions/company.actions";
import { searchCitiesAutocomplete } from "../../../../actions/cities.actions";

class CompanyProfileContainer extends Component {
  constructor(props) {
    super(props);
    this.handleSubmit = this.handleSubmit.bind(this);
  }

  componentDidMount() {
    this.props.fetchCompanySizes();
    this.props.fetchIndustries();
  }

  handleSubmit(data) {
    if (data.location && data.location.length > 0) {
      data.location = data.location[0].description;
    }
    this.props.updateCompany(data);
  }

  render() {
    return (
      <CompanyProfile
        onSubmit={this.handleSubmit}
        industries={this.props.industries}
        companySizes={this.props.companySizes}
        companyName={this.props.match.params.companyName}
        cities={this.props.cities}
        onSearchCities={this.props.searchCitiesAutocomplete}
      />
    );
  }
}

const mapStateToProps = state => {
  return {
    industries: state.dropdowns.industries.data,
    companySizes: state.dropdowns.companySizes.data,
    cities: state.cities.cities.predictions,
    isLoading: state.cities.cities.isLoading
  };
};

const mapDispatchToProps = dispatch => ({
  fetchIndustries: () => dispatch(fetchIndustries()),
  fetchCompanySizes: () => dispatch(fetchCompanySizes()),
  updateCompany: company => dispatch(updateCompany(company)),
  searchCitiesAutocomplete: query => dispatch(searchCitiesAutocomplete(query))
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(CompanyProfileContainer);



// WEBPACK FOOTER //
// ./src/routes/employer/signUp/containers/CompanyProfileContainer.js